"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configSchema = void 0;
const configuration_1 = require("../configuration");
const configSchema = (0, configuration_1.ConfigurationSchema)('BaseFeatureWidget', {});
exports.configSchema = configSchema;
